<template>
  <div class="listPage">
    <div class="banner">
      <img src="../../assets/images/banner3.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <!-- <div class="breadcrumb_icon3">
        <i class="iconfont icon-pinpaizichanpingtai"></i>
      </div> -->
      <div class="breadcrumb_item">促销优惠&市场活动</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">市场活动管理</div>
    </div>

    <div class="input_box flex-between">
      <van-field
        v-model="params.keyword"
        placeholder="关键词查找→"
        @focus="handleFocus"
        @blur="handleBlur"
        @keyup.enter="handleSearch"
      />
      <i class="iconfont icon-sousuo" @click="handleSearch"></i>
    </div>

    <div class="order_wrap">
      <template v-if="dataList.length > 0">
        <div
          class="order_item"
          v-for="item in dataList"
          :key="item.id"
          @click="handleDetail(item.id)"
        >
          <div class="row_one mb">
            <p>
              活动：<span>{{ item.actidstr }}</span>
            </p>
            <p>
              姓名：<span>{{ item.truename }}</span>
            </p>
            <p>
              手机号：<span>{{ item.mobile }}</span>
            </p>
            <p>
              预约日期：<span>{{ item.createdate }}</span>
            </p>
          </div>
        </div>
      </template>
      <van-empty
        v-else-if="dataList.length == 0 && !loading"
        description="暂无数据"
      />

      <!-- <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i> 返回业务中心
      </div> -->
    </div>

    <!-- <Tabbar v-if="isShowTabbar"></Tabbar> -->
    <div class="fixd_button_btm" v-if="isShowTabbar">
      <div class="item" @click="handleReturn">返回</div>
    </div>
  </div>
</template>

<script>
import { encryptstringview } from "../../api/api";
import { getActivityLogList } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "outboundList",
  components: {
    // Tabbar,
  },
  data() {
    return {
      isShowTabbar: true,
      listTotal: 0,
      dataList: [],
      params: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        actid: "",
      },
      loading: false, // 是否正在加载中
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID, menuItem, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.roleId = USERINFO.roleid;
    this.menuItem = menuItem;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.params.actid = id;
        this.initData();
      } else {
        this.$router.back();
      }
    },

    // 搜索
    handleSearch() {
      this.params.pageindex = 1;
      this.dataList = [];
      this.initData();
    },
    initData() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getActivityLogList(this.params).then((res) => {
        this.dataList = [...this.dataList, ...res.list];
        this.listTotal = res.total;
        this.loading = false;
        Toast.clear();
      });
    },
    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (
        scrollTop + windowHeight >= documentHeight &&
        !this.loading &&
        this.dataList.length < this.listTotal
      ) {
        this.params.pageindex += 1;
        this.initData();
      }
    },

    handleReturn() {
      this.$router.back();
    },

    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },
  },
};
</script>
<style lang="less" scoped>
.listPage {
  padding-bottom: 300px;
  .screen_wrap {
    font-size: 20px;
    color: #464646;
    flex-wrap: wrap;
    margin: 70px 70px 60px;
    .item {
      border: 1px solid #d2d2d2;
      height: 40px;
      line-height: 40px;
      padding: 0 10px 0 19px;
      margin-right: 10px;
      margin-bottom: 20px;
      span {
        width: 40px;
        display: inline-block;
        margin-left: 20px;
        .iconfont {
          font-size: 30px;
        }
      }
    }
  }
  .order_wrap {
    margin: 40px auto;
    .order_item {
      width: 650px;
      border: 1px solid #d2d2d2;
      margin: 0 auto 30px;
      padding: 40px;
      font-size: 20px;
      color: #3c3c3c;
      box-sizing: border-box;
      .row_one {
        font-size: 22px;
        &.mb {
          margin-bottom: 40px;
        }
        p {
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .row_shop_list {
        margin: 27px 0 55px;
        color: #3c3c3c;
        .shop_item {
          margin-bottom: 30px;
        }
        .shop_name_num {
          margin-bottom: 22px;
          .shop_name_num_item {
            align-items: flex-start;
            margin-bottom: 4px;
          }
          p {
            font-size: 20px;
            &.label {
              white-space: nowrap;
            }
          }
        }
        .shop_price {
          font-size: 18px;
          .txt {
            margin-top: 10px;
          }
        }
      }
      .row_two {
        margin-bottom: 40px;
        p {
          margin-bottom: 6px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .row_three {
        margin-bottom: 36px;
        font-size: 22px;
      }
      .row_four {
        margin-bottom: 50px;
        font-size: 22px;
        span {
          margin-right: 17px;
        }
        .txt {
          margin-bottom: 10px;
          p {
            &:last-child {
              font-size: 30px;
            }
          }
          span {
            font-size: 20px;
          }
        }
        .txt1 {
          margin-bottom: 30px;
        }
      }
      .order_status {
        font-size: 22px;
        .txt {
          margin-bottom: 10px;
        }
        .red {
          color: #ee0032;
        }
      }
    }
  }
}
</style>